<template>
  <div id="accountManagement">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            社區帳號管理
          </div>
          <div class="tip">
            可管理社區後台系統帳號權限及所能操作之功能，增加系統安全性
          </div>
        </div>
      </div>
      <el-tabs
        id="feeTab"
        v-model="activeName"
        :before-leave="checkTab"
      >
        <el-tab-pane name="accountList">
          <span slot="label">已開通帳號</span>
        </el-tab-pane>
        <el-tab-pane name="accountRecord">
          <span slot="label">序號發放紀錄</span>
        </el-tab-pane>
      </el-tabs>
      <router-view ref="view" />
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeName: 'accountList'
    }
  },
  mounted () {
    console.log('heyhey', this.activeName)
    this.activeName = this.$route.name
  },
  methods: {
    checkTab (activeName, oldActiveName) {
      if (activeName !== oldActiveName) {
        this.$router.push({ name: activeName })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#accountManagement
  text-align: center
  padding: 50px 0 10px
  height: 100%
  .main
    min-width: 1140px
    max-width: 90%
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 0 20px 0
      .introduction
        color: $mainColorDark
        font-size: 20px
        font-weight: initial
        margin: 0 10px
        text-decoration: underline
        cursor: pointer
        &:before
          content: '('
          color: #000
        &:after
          content: ')'
          color: #000
      .questionnaire
        background-color: $bgDark3
        padding: 5px 8px
        span
          color: $mainColor
          cursor: pointer
          margin: 0 10px 0 13px
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        margin-bottom: 10px
        text-align: left
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
    .title_bar.center
      margin: 20px 0 10px 0
#feeTab
  ::v-deep .el-tabs
    +basicTabs
    &__header
      margin: 0 0 0
    &__item
      min-width: 130px
      height: 42px
      span
        width: 100%
        display: inline-block
</style>
